import { h, Component, Fragment } from 'preact'
import { SVG, Bubble } from '.'

class Form extends Component {
  constructor() {
    super()
    this.state = { fields: {} }
    this.DOMNodes = {}
  }

  handleSkip() {
    const { onSubmit, fields } = this.props
    if (!onSubmit) return

    const f = {}
    for (let field of fields) {
      f[field.name] = ''
    }

    this.setState({ submitted: true })
    onSubmit(f)
  }

  handleSubmit(e) {
    e.preventDefault()

    const { onSubmit, fields } = this.props
    if (!onSubmit || this.state.submitted || !this.validateFields()) return

    const f = {}
    for (let field of fields) {
      const fieldState = this.state.fields[field.name]
      f[field.name] = fieldState ? fieldState.value : ''
    }

    this.setState({ submitted: true })
    onSubmit(f)
  }

  handleInput(e, field) {
    let value = e.currentTarget.value
    this.validateField(field, value)
  }

  handleCheckbox(e, field) {
    let checked = e.currentTarget.checked
    this.validateField(field, checked)
  }

  validateFields() {
    const { fields } = this.props
    let valid = true
    let focused = false

    for (let field of fields) {
      if (this.validateField(field) == false) {
        valid = false

        if (!focused) {
          focused = true
          this.focusField(field)
        }
      }
    }

    return valid
  }

  validateField(field, value) {
    const fields = this.state.fields
    if (value == undefined) {
      value = fields[field.name] ? fields[field.name].value : ''
    }

    let valid = undefined

    if (field.required || field.validate) {
      valid = true

      if (field.required) {
        if (field.type == 'checkbox') {
          if (!value) valid = false
        } else if (!value.trim().length) {
          valid = false
        }
      }

      if (valid && field.validate) {
        if (value) {
          valid = field.validate(value)
        } else if (!field.required) {
          valid = undefined
        }
      }
    }

    fields[field.name] = { value, valid }

    this.setState({ fields })
    return valid
  }

  focusField(field) {
    const DOMNode = this.DOMNodes[field.name]
    if (!DOMNode) return

    DOMNode.focus()
  }

  render() {
    const { config, fields } = this.props
    const { messages } = config

    let hasRequiredFields = false

    return (
      <div class="row entry">
        <form
          class="bubble"
          disabled={this.state.submitted}
          onSubmit={(e) => this.handleSubmit(e)}
        >
          <div class="row">
            {fields.map((field) => {
              const { type, name, label, required } = field
              let { placeholder } = field

              const fieldState = this.state.fields[name] || {
                value: '',
                valid: undefined,
              }

              if (required && !this.state.submitted) {
                hasRequiredFields = true

                if (placeholder) {
                  placeholder += ' *'
                }
              }

              return (
                <div
                  data-filled={!!fieldState.value}
                  data-valid={fieldState.valid == true}
                  data-error={fieldState.valid == false}
                  class="input-placeholder"
                >
                  {type == 'checkbox' ? (
                    <label>
                      <input
                        type="checkbox"
                        disabled={this.state.submitted}
                        onChange={(e) => this.handleCheckbox(e, field)}
                      />
                      <div>
                        <Bubble body={label} onlyContent={true} />
                      </div>
                    </label>
                  ) : (
                    <input
                      type={type}
                      value={fieldState.value}
                      disabled={this.state.submitted}
                      ref={(input) => {
                        this.DOMNodes[name] = input
                      }}
                      onInput={(e) => this.handleInput(e, field)}
                    />
                  )}

                  {placeholder && (
                    <span class="placeholder">{placeholder}</span>
                  )}

                  {!this.state.submitted && (
                    <Fragment>
                      <SVG name="error" size={20} />
                      <SVG name="valid" size={20} />
                    </Fragment>
                  )}
                </div>
              )
            })}
          </div>

          {hasRequiredFields && (
            <div class="row">
              <span class="light-text small-text">
                * {messages.identifyRequired}
              </span>
            </div>
          )}

          {!this.state.submitted && (
            <div class="row buttons">
              <div>
                {!hasRequiredFields && (
                  <button
                    class="button"
                    type="button"
                    onClick={() => {
                      this.handleSkip()
                    }}
                  >
                    {messages.identifySkip}
                  </button>
                )}
                <button class="button submit" type="submit">
                  {messages.identifySubmit}
                </button>
              </div>
            </div>
          )}
        </form>
      </div>
    )
  }
}

export default Form
